import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// route level code-splitting
// this generates a separate chunk ([name].[hash].js) for this route
// which is lazy-loaded when the route is visited.
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/plan2022',
      name: 'plan2022',
      component: () => import(/* webpackChunkName: "about-us" */ './views/plan2022.vue')
    },
    {
      path: '/about-us',
      name: 'aboutUs',
      redirect: 'about-us/talkmate-intro',
      component: () => import(/* webpackChunkName: "about-us" */ './views/about_us/Index.vue'),
      children: [
        {
          path: 'talkmate-intro',
          name: 'talkmateIntro',
          component: () => import(/* webpackChunkName: "talkmate-intro" */ './views/about_us/TalkmateIntro.vue')
        },
        {
          path: 'utn-intro',
          name: 'utnIntro',
          component: () => import(/* webpackChunkName: "utn-intro" */ './views/about_us/UtnIntro.vue')
        },
        {
          path: 'professonal-committee',
          name: 'professonalCommittee',
          component: () => import(/* webpackChunkName: "professonal-committee" */ './views/about_us/ProfessonalCommittee.vue')
        },
        {
          path: 'join-us',
          name: 'joinUs',
          component: () => import(/* webpackChunkName: "join-us" */ './views/about_us/JoinUs.vue')
        }
      ]
    },
    {
      path: '/product-service',
      name: 'productService',
      redirect: 'product-service/talkmate',
      component: () => import(/* webpackChunkName: "product-service" */ './views/product_service/Index.vue'),
      children: [
        {
          path: 'talkmate',
          name: 'talkmate',
          component: () => import(/* webpackChunkName: "talkmate" */ './views/product_service/Talkmate.vue')
        },
        // {
        //   path: 'children-course',
        //   name: 'childrenCourse',
        //   component: () => import(/* webpackChunkName: "children-course" */ './views/product_service/ChildrenCourse.vue')
        // },
        {
          path: 'pro-course',
          name: 'proCourse',
          component: () => import(/* webpackChunkName: "pro-course" */ './views/product_service/ProCourse.vue')
        },
        {
          path: 'children-class',
          name: 'childrenClass',
          component: () => import(/* webpackChunkName: "children-class" */ './views/product_service/ChildrenClass.vue')
        },
        {
          path: 'partner',
          name: 'partner',
          component: () => import(/* webpackChunkName: "partner" */ './views/product_service/Partner.vue')
        },
        {
          path: 'download',
          name: 'download',
          component: () => import(/* webpackChunkName: "partner" */ './views/product_service/Download.vue')
        },
        {
          path: 'web-resource',
          name: 'WebResource',
          component: () => import(/* webpackChunkName: "web-resource" */ './views/product_service/WebResource.vue')
        },
        {
          path: 'translation',
          name: 'translation',
          component: () => import(/* webpackChunkName: "translation" */ './views/product_service/translation.vue')
        }
      ]
    },
    {
      path: '/learning-commonweal',
      name: 'learningCommonweal',
      redirect: 'learning-commonweal/lang-protection',
      component: () => import(/* webpackChunkName: "learning-commonweal" */ './views/learning_commonweal/Index.vue'),
      children: [
        {
          path: 'lang-protection',
          name: 'langProtection',
          component: () => import(/* webpackChunkName: "lang-protection" */ './views/learning_commonweal/LangProtection.vue')
        },
        {
          path: 'lang-competition',
          name: 'langCompetition',
          component: () => import(/* webpackChunkName: "lang-competition" */ './views/learning_commonweal/LangCompetition.vue')
        }
      ]
    },
    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "news" */ './views/news/Index.vue')
    },
    {
      path: '/news/detail',
      name: 'newsDetail',
      component: () => import(/* webpackChunkName: "detail" */ './views/news/newsDetail.vue')
    },
    {
      path: '/news/list',
      name: 'newsList',
      component: () => import(/* webpackChunkName: "list" */ './views/news/newsList.vue')
    }
  ]
})
